import React from 'react';
import { render } from '@testing-library/react';

import { Form } from '../Form/';

describe('Form.Group', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Form>
				<Form.Group data-auto-sel="automation-selector">
					<Form.Checkbox label="Apples" />
					<Form.Checkbox label="Oranges" />
					<Form.Checkbox label="Pears" />
					<Form.Checkbox label="Grapefruit" />
				</Form.Group>
			</Form>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
